import { isDefined } from '@evorait/pace-core';
import { on } from '@ngrx/store';
import { Choices } from '../../../types/choice';
import { ContentId } from '../../../types/content-block';
import { FormsConstants } from '../../../types/forms-constants';
import { ValueFunctionalElement } from '../../../types/value-functional-element';
import { updateValue } from '../../actions/functional-elements.actions';
import { FormState } from '../../state/form.state';
import { updateStateAfterContentChanges } from './form-reducer.utilities';

export function updateValueReducer(
    state: Readonly<FormState>,
    props: { id: ContentId; xmlId: string; newValue: string; valid: boolean },
): Readonly<FormState> {
    const oldValueFunctionalElement = state.participantCopies[state.selectedParticipantCopyId].functionalElements[
        props.id
    ] as ValueFunctionalElement;

    if (oldValueFunctionalElement.value === props.newValue) {
        return state;
    }

    const newValueFunctionalElement: { [key: string]: Readonly<ValueFunctionalElement> } = {};
    newValueFunctionalElement[props.id] = { ...oldValueFunctionalElement, value: props.newValue };
    const oldChoices = oldValueFunctionalElement.choices;
    if (isDefined(oldChoices)) {
        const newChoices: Choices = Object.keys(oldChoices).reduce((accu, key: keyof Choices) => {
            const choice = oldChoices[key];
            const selected =
                props.newValue === ''
                    ? false
                    : props.newValue === FormsConstants.NA
                      ? key === 'choiceNa'
                      : props.valid
                        ? key === 'choicePositive'
                        : key === 'choiceNegative';
            return {
                ...accu,
                [key]: {
                    ...choice,
                    selected: selected,
                    selectedInMaster:
                        state.selectedParticipantCopyId === FormsConstants.MASTER_PARTICIPANT_ID
                            ? selected
                            : choice?.selectedInMaster,
                },
            };
        }, {});
        newValueFunctionalElement[props.id] = { ...newValueFunctionalElement[props.id], choices: newChoices };
    }
    return updateStateAfterContentChanges(state, {
        ...state.participantCopies[state.selectedParticipantCopyId].functionalElements,
        ...newValueFunctionalElement,
    });
}

export const valueReducer = [on<FormState, Array<typeof updateValue>>(updateValue, updateValueReducer)];
